import { NcIntegrationActionConfig, Rate } from "generated/graphql.schema";
import i18n, { LocalKeys } from "utilities/i18n";

//Divider should come before Daily but after intervals.
//The ordering of rates is guaranteed by NC service
export const getDividerIndex = (rates: Array<String>) => {
  return rates.indexOf(Rate.Daily) - 1;
};

export const getFrequencyOptions = (configData: NcIntegrationActionConfig) => {
  const frequencyOptions = configData!.allowedRates.map((el: Rate) => {
    return {
      value: el,
      text: i18n.t(el as LocalKeys)
    };
  });

  return frequencyOptions;
};
